import { IconButton, InputAdornment, TextField } from '@mui/material'
import React, { useEffect, useState } from 'react'
import GenerateIcon from '../GenerateIcon'
import { IBaseDynamicFormElement } from '../Form/DynamicForm'
import ScanQRCode from '../../features/items/ScanQRCode'
import { useDispatch } from 'react-redux'
import { handleRequestError } from '../../services/api'
import { IStrongPasswordResponse, verifyStrongPassword } from '../../features/user/UsersApp'
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import Attachments, { IAttachment } from '../Attachments'

export default function AttachmentsField(props: IBaseDynamicFormElement) {

    const { 
        id,
        handleOnChange, 
        data,
        label,
    } = props

    const dispatch = useDispatch()

    const [attachments, setAttachments] = useState<IAttachment[]>(data.value)

    useEffect(() => {
        if (data.value){
            setAttachments(data.value)
        }
    }, [data])

    return(
        <div>
            <div>
                <Attachments attachments={attachments} setAttachments={(attachments) => {
                    handleOnChange(id, attachments)
                    setAttachments(attachments)
                }} label={label ? label : "Images"} />
            </div>
        </div>
    )
}